import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import GetAllTransports from "../../../../Controllers/Common/GetAllTransports";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function TransportListingViewModel() {
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [AuthUser, setAuthUser] = useState();
  const [TransportsArray, setTransportsArray] = useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const TransportsData = await GetAllTransports(SchoolID);
      setTransportsArray(TransportsData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  return {
    TransportsArray,
    AuthUser,
    IsLoading,
  };
}
